import React, { useEffect, useState, useRef } from 'react';
import { Col, Layout, Modal, notification, Row, Spin, Tabs, Tag } from 'antd';
import { useModal } from "hooks";
import useKeypress from "react-use-keypress";
import { Header as Nav } from 'components/Header';
import './EditAdBlock.css';
import { Footer } from 'components/Footer';
import AgentTraceLink from 'components/AgentTraceLink';
import { Header } from 'antd/es/layout/layout';
import Button from './components/Button';
import { FiPackage } from 'react-icons/fi';
import { MdLocalOffer } from 'react-icons/md';
import { IoAdd, IoCheckmark, IoTextOutline } from 'react-icons/io5';
import { useParams, navigate } from "@reach/router";
import { ImageMatchingModal, UnitRestrictionWarning, TeaSizeWarning } from "modals";
import { SpaceAfterSlashWarningModal } from "modals/commons/SpaceAfterSlashWarningModal";
import useAdBlockStore from 'store/AdBlockStore';
import { useDataStore } from "store/DataStore";
import { PageImagePreview } from './components/PageImagePreview';
import PageActions from './components/PageActions';
import { ImagePreview } from './components/ImagePreview';
import { NetUnitPriceModal, ScrollView } from 'components';
import MetaDataSelector from './components/MetaDataSelector';
import BuilderPanel from './components/BuilderPanel';
import ProductPreview from './components/Products/ProductPreview';
import { ProductBuilder } from './components/Products/ProductBuilder';
import { OfferPreview } from './components/Offers/OfferPreview';
import { OfferIncentiveBuilder } from './components/Offers/OfferIncentiveBuilder';
import ProductLeftPanel from './components/Products/LeftPanel';
import OfferLeftPanel from './components/Offers/LeftPanel';
import EventSelector from './EventSelector';
import { validateLiner, unitSizeRestrictionMessage, calculateNetCost, validatePrice, checkDupeEntry, checkTeaSizeViolation, checkMinQtyDollarF, checkSpaceAfterSlash, normalizeWPurchaseText, isValidPriceEAOffers } from 'utils';
import { getCurrentUserAPI, overrideAdblock, getCloningApi } from 'api';
import { useMainContext } from "contexts"
import { OCR_VALIDATION_RULES } from 'config/ocrValidationRules';
import { isCraftBeerBogoViolation, CRAFT_BEER_BOGO_MESSAGE } from 'config/craftBeerBogoValidation';

const { Sider, Content } = Layout;

const OCRPanel = ({
  ocrText = '',
  htmlText = '',
  setShowOcrText = () => {}
}) => {
  const sectionHeadingStyle = {
    fontWeight: 'bold',
    fontSize: '11px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    color: '#bbb',
    marginBottom: '4px',
  };
  const emptyStyle = { color: '#888', fontStyle: 'italic' };
  return (
    <div style={{
                    position: 'absolute',
                    top: '8px',
                    right: '8px',
                    maxHeight: '60%',
                    width: '320px',
                    maxWidth: 'calc(100% - 16px)',
                    overflow: 'auto',
                    padding: '12px',
                    background: 'rgba(0, 0, 0, 0.9)',
                    color: '#fff',
                    fontFamily: 'monospace',
                    fontSize: '13px',
                    lineHeight: '1.5',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    borderRadius: '8px',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5)',
                    zIndex: 10,
                  }}>
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginBottom: '8px',
                      paddingBottom: '6px',
                      borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                    }}>
                      <span style={{ fontWeight: 'bold', fontSize: '11px', textTransform: 'uppercase' }}>OCR / HTML Text</span>
                      <button
                        onClick={() => setShowOcrText(false)}
                        style={{
                          background: 'transparent',
                          border: 'none',
                          color: '#999',
                          cursor: 'pointer',
                          fontSize: '16px',
                          padding: '0',
                          lineHeight: 1,
                        }}
                      >×</button>
                    </div>
                    <div>
                      <div style={sectionHeadingStyle}>OCR Text</div>
                      <div>{ocrText || <span style={emptyStyle}>No OCR text available</span>}</div>
                    </div>
                    <div style={{
                      marginTop: '12px',
                      paddingTop: '12px',
                      borderTop: '1px solid rgba(255, 255, 255, 0.1)',
                    }}>
                      <div style={sectionHeadingStyle}>HTML Text</div>
                      <div>{htmlText || <span style={emptyStyle}>No HTML text available</span>}</div>
                    </div>
                  </div>
  )
};

export const EditAdBlock = () => {
  const initPage = useAdBlockStore(state => state.initPage);
  const activePageData = useAdBlockStore(state => state.activePageData);
  const activeBlockData = useAdBlockStore(state => state.activeBlockData);
  const leftPanelView = useAdBlockStore(state => state.leftPanelView);
  const approveProduct = useAdBlockStore(state => state.approveProduct);
  const approveOffer = useAdBlockStore(state => state.approveOffer);
  const isLoading = useAdBlockStore(state => state.isLoading);
  const isApproving = useAdBlockStore(state => state.isApproving);
  const isRejecting = useAdBlockStore(state => state.isRejecting);
  const isDNELoading = useAdBlockStore(state => state.isDNELoading);
  const circularName = useAdBlockStore(state => state.circularName);
  const circularType = useAdBlockStore(state => state.circularType);
  const handleImportProduct = useAdBlockStore(state => state.handleImportProduct);
  const handleImportOffer = useAdBlockStore(state => state.handleImportOffer);
  const navigateNextUnapproved = useAdBlockStore(state => state.navigateNextUnapproved);
  const initializeProductStartTime = useAdBlockStore(state => state.initializeProductStartTime);
  const initializeOfferStartTime = useAdBlockStore(state => state.initializeOfferStartTime);
  const setActiveBlockData = useAdBlockStore(state => state.setActiveBlockData);
  const currentProduct = useAdBlockStore(state => state.currentProduct);
  const currentOffer = useAdBlockStore(state => state.currentOffer);
  const products = useAdBlockStore(state => state.products);
  const offers = useAdBlockStore(state => state.offers);
  const incentives = useAdBlockStore(state => state.incentives);
  const split = useAdBlockStore(state => state.split);
  const updateMetaDataField = useAdBlockStore(state => state.updateMetaDataField);
  const imageMatchStatus = useAdBlockStore(state => state.imageMatchStatus);
  const imageMatchApplicable = useAdBlockStore(state => state.imageMatchApplicable);
  const imageMatchTraceId = useAdBlockStore(state => state.imageMatchTraceId);
  const productSizes = useDataStore((state) => state.productSizes);

  // True only for candy-suggestion blocks whose agent product suggestions are still in progress.
  // 'failed' is intentionally excluded so a failed/unrecoverable job never blocks entry.
  const isGeneratingSuggestions =
    imageMatchApplicable && ["pending", "processing"].includes(imageMatchStatus);

  const isLinerDisabled = !products.some((product) => product?.liner_f === true);
  const arePriceEaOffersValid = isValidPriceEAOffers(offers, isLinerDisabled, split);

  const { circular, page, adblock } = useParams();
   const {
      liveCounterData,
      setLiveCounterData
    } = useMainContext();

  const [activeKey, setActiveKey] = useState('product');
  const [netCostValues, setNetCostValues] = useState([]);
  const [netUnitPriceModal, setNetUnitPriceModal] = useState(false);
  const [unitRestrictionModal, setUnitRestrictionModal] = useState(false);
  const [unitRestrictionMessage, setUnitRestrictionMessage] = useState({});
  const [teaSizeWarningModal, setTeaSizeWarningModal] = useState(false);
  const [priceWarningModelOpen, setPriceWarningModelOpen] = useState(false);
  const [priceWarningMessage, setPriceWarningMessage] = useState('');
  const [largeSaveOfferModalOpen, setLargeSaveOfferModalOpen] = useState(false);
  const [largeSaveOfferMessage, setLargeSaveOfferMessage] = useState('');
  const [showAdblockValidationModal, setShowAdblockValidationModal] = useState(false);
  const [adblockValidationMessage, setAdblockValidationMessage] = useState('');
  const [ocrValidationModal, setOcrValidationModal] = useState({ open: false, rule: null });
  const [craftBeerBogoModalOpen, setCraftBeerBogoModalOpen] = useState(false);
  const [force, setForce] = useState(false);
  const [showOcrText, setShowOcrText] = useState(false);
  const [isSelectVarietiesWarningOpen, setIsSelectVarietiesWarningOpen] = useState(false);
  const [selectVarietiesWarningMessage, setSelectVarietiesWarningMessage] = useState('');
  const [pendingSkipOcrValidation, setPendingSkipOcrValidation] = useState(false);
  const [spaceWarningModalOpen, setSpaceWarningModalOpen] = useState(false);
  const [spaceWarningMessage, setSpaceWarningMessage] = useState('');

  const productBuilderRef = useRef(null);
  const offerBuilderRef = useRef(null);
  const productLeftPanelRef = useRef(null);
  const offerLeftPanelRef = useRef(null);

  const imageMatchingModal = useModal();

  // For Training Circulars the Similar Block popup is gated by the Cloning
  // (check_dupe) setting; all other circular types open the popup as before.
  const openImageMatchingModalIfAllowed = async () => {
    if (circularType === "Training Circular") {
      const res = await getCloningApi({ circ_type: "Training Circular" });
      if (!(res.success && res.results && res.results.check_dupe)) {
        return;
      }
    }
    imageMatchingModal.openModal();
  };

  useEffect(() => {
    if (activeBlockData) {
      setForce(false);
      if (!activeBlockData.products_approved || (activeBlockData.products_approved && activeBlockData.offers_approved)) {
        setActiveKey('product');
        initializeProductStartTime();
        if (
          activeBlockData.similar_adblock_uuid &&
          !activeBlockData.products_approved &&
          !activeBlockData.is_dupe) {
          openImageMatchingModalIfAllowed()
        }
      } else {
        setActiveKey('offer');
        initializeOfferStartTime();
        if (
          activeBlockData.similar_adblock_uuid &&
          !activeBlockData.offers_approved &&
          !activeBlockData.is_dupe &&
          !activeBlockData?.products_approved &&
          !activeBlockData?.product_dupe_of) {
          openImageMatchingModalIfAllowed()
        }
      }
    }
  }, [activeBlockData])

  const approveButtonStyle = () => {
    if (
      (activeKey === 'product' && activeBlockData.products_approved) ||
      (activeKey === 'offer' && activeBlockData.offers_approved)
    ) {
      return {
        type: 'success',
        text: 'APPROVED'
      };
    }
    return {
      type: 'default',
      text: 'APPROVE'
    };
  }

  const leftPanelTitle = () => {
    console.log(leftPanelView)
    switch (leftPanelView) {
      case 'brand':
        return 'Create Brand';
      case 'suggestions':
        return 'Suggestions';
      default:
        return 'Products';
    }
  }

  useEffect(() => {
    if (circular && page && adblock) {
      console.log("Initializing page with circular:", circular, "page:", page, "adblock:", adblock);
      initPage({ id: circular, currentPageID: page, currentAdBlockID: adblock });
    } else {
      navigate('/home');
    }
  }, [circular]);

  useEffect(() => {
    // If the URL parameters are not valid, redirect to the home page
    if (!circular || !page || !adblock) {
      navigate('/home');
    }
  }, [circular, page, adblock]);

  useEffect(() => {
    const normalizedOffers = (offers || []).map((offer) => ({
      ...offer,
      offer_text: normalizeWPurchaseText(offer?.offer_text),
    }));
    const normalizedIncentives = (incentives || []).map((incentive) => ({
      ...incentive,
      incentive_text: normalizeWPurchaseText(incentive?.incentive_text),
    }));

    const offersChanged = normalizedOffers.some(
      (offer, index) => offer.offer_text !== offers[index]?.offer_text
    );
    const incentivesChanged = normalizedIncentives.some(
      (incentive, index) =>
        incentive.incentive_text !== incentives[index]?.incentive_text
    );

    const normalizedCurrentOffer = currentOffer
      ? {
          ...currentOffer,
          offer_text: normalizeWPurchaseText(currentOffer?.offer_text),
          incentive_text: normalizeWPurchaseText(currentOffer?.incentive_text),
        }
      : currentOffer;
    const currentOfferChanged =
      !!currentOffer &&
      (normalizedCurrentOffer.offer_text !== currentOffer.offer_text ||
        normalizedCurrentOffer.incentive_text !== currentOffer.incentive_text);

    if (offersChanged || incentivesChanged || currentOfferChanged) {
      useAdBlockStore.setState({
        ...(offersChanged ? { offers: normalizedOffers } : {}),
        ...(incentivesChanged ? { incentives: normalizedIncentives } : {}),
        ...(currentOfferChanged ? { currentOffer: normalizedCurrentOffer } : {}),
      });
    }
    
    // check every 'Store Savings' Adblock incentive, loyalty_f must be true.
    incentives.forEach((incentive) => {
      if (incentive?.incentive_attach_to === 'Adblock' && incentive?.incentive_type === 'Store Savings' && useAdBlockStore.getState().getMetaData().loyalty_f !== true) {
        updateMetaDataField("loyalty_f", true);
      }
    });
  }, [offers, incentives, currentOffer]);

  const tabItems = [
    {
      key: 'product',
      label: `Product Entry`,
      icon: <FiPackage size={18} />,
      children: <BuilderPanel
        preview={<ProductPreview />}
        rightPanel={{
          label: 'Product Details',
          content: <div ref={productBuilderRef}><ProductBuilder /></div>
        }}
        leftPanel={{
          label: leftPanelTitle(),
          content: <div ref={productLeftPanelRef}><ProductLeftPanel /></div>
        }}
      />
    },
    {
      key: 'offer',
      label: 'Offer Entry',
      icon: <MdLocalOffer size={18} />,
      children: <BuilderPanel
        preview={<OfferPreview />}
        rightPanel={{
          label: 'OFFERS & INCENTIVES',
          content: <div ref={offerBuilderRef}><OfferIncentiveBuilder /></div>
        }}
        leftPanel={{
          label: 'QUICK SELECTION',
          content: <div ref={offerLeftPanelRef}><OfferLeftPanel /></div>
        }}
      />
    },
  ];

  // Add products/offers
  useKeypress(["+"], (event) => {
    // Ignore OS key-repeat: holding the key must not create a row per repeat.
    if (event.repeat) return;
    if (event.altKey) {
      if (activeKey === 'product') {
        if (!(isLoading || isApproving || isRejecting || isDNELoading)) {
          useAdBlockStore.getState().addProduct();
        }
      }
      else if (activeKey === 'offer') {
        if (!(isLoading || isApproving || isRejecting || isDNELoading)) {
          useAdBlockStore.getState().addNewOffer();
        }
      }
    }
  });

  //Approve products/offers
  useKeypress(["q", "Q"], (event) => {
    // Ignore OS key-repeat: holding Alt+Q must not re-trigger approval.
    if (event.repeat) return;
    if (event.altKey) {
      if (activeKey === 'product') {
        if (!(isLoading || isApproving || isRejecting || isDNELoading || products.some(product => !product.isValid) || activeBlockData.is_dupe)) {
          handleApproveProduct();
        }
      }
      else if (activeKey === 'offer') {
        if (!(isLoading || isApproving || isRejecting || isDNELoading || offers.some(offer => !offer.isValid) || incentives.some(incentive => !incentive.isValid) || !arePriceEaOffersValid || activeBlockData.is_dupe)) {
          handleApproveOffer();
        }
      }
    }
  });

  // Helper to get focusable elements in a container
  const getFocusableElements = (container) => {
    if (!container) return [];
    const selector = [
      "input:not([type='hidden']):not([disabled])",
      "select:not([disabled])",
      "textarea:not([disabled])",
      "button:not([disabled])",
      "[tabindex]:not([tabindex='-1']):not([disabled])"
    ].join(",");
    return Array.from(container.querySelectorAll(selector));
  };

  // Get active left panel ref based on current tab
  const getActiveLeftPanelRef = () => {
    return activeKey === 'product' ? productLeftPanelRef : offerLeftPanelRef;
  };

  // Get active builder ref based on current tab
  const getActiveBuilderRef = () => {
    return activeKey === 'product' ? productBuilderRef : offerBuilderRef;
  };

  // Handle Tab navigation between left panel
  useEffect(() => {
    //open Image Matching Modal again when view changes
    if (
      activeBlockData?.similar_adblock_uuid &&
      !activeBlockData?.is_dupe &&
      (activeKey === 'product' || activeKey === 'offer') &&
      !activeBlockData?.[`${activeKey}s_approved`]
    ) {
      openImageMatchingModalIfAllowed()
    }

    const handleTabNavigation = (e) => {
      if (e.key !== 'Tab') return;

      const leftPanelRef = getActiveLeftPanelRef();
      const builderRef = getActiveBuilderRef();

      if (!leftPanelRef?.current || !builderRef?.current) return;

      const leftPanelElements = getFocusableElements(leftPanelRef.current);
      const builderElements = getFocusableElements(builderRef.current);
      const activeElement = document.activeElement;

      // Check if focus is in left panel
      const leftPanelIndex = leftPanelElements.indexOf(activeElement);
      if (leftPanelIndex !== -1) {
        e.preventDefault();
        e.stopPropagation(); // to handle right TAB ovveride
        if (!e.shiftKey) {
          // Tab forward
          if (leftPanelIndex === leftPanelElements.length - 1) {
            // Last element in left panel, Tab moves to first builder element
            builderElements[0]?.focus();
          } else {
            // Move to next element in left panel
            leftPanelElements[leftPanelIndex + 1]?.focus();
          }
        } else {
          // Shift+Tab backward
          if (leftPanelIndex === 0) {
            // First element, wrap to last element in left panel
            leftPanelElements[leftPanelElements.length - 1]?.focus();
          } else {
            // Move to previous element in left panel
            leftPanelElements[leftPanelIndex - 1]?.focus();
          }
        }
        return;
      }

      // Check if focus is in builder
      const builderIndex = builderElements.indexOf(activeElement);
      if (builderIndex !== -1) {
        if (e.shiftKey && builderIndex === 0) {
          // First element in builder, Shift+Tab moves to last left panel element
          e.preventDefault();
          leftPanelElements[leftPanelElements.length - 1]?.focus();
          return;
        }
      }
    };

    document.addEventListener('keydown', handleTabNavigation);
    return () => document.removeEventListener('keydown', handleTabNavigation);
  }, [activeKey]);

  // Alt+B shortcut to focus left panel from builder
  useKeypress(['b', 'B'], (event) => {
    if (event.altKey) {
      event.preventDefault();
      const leftPanelRef = getActiveLeftPanelRef();
      const builderRef = getActiveBuilderRef();

      if (!leftPanelRef?.current || !builderRef?.current) return;

      const leftPanelElements = getFocusableElements(leftPanelRef.current);
      const builderElements = getFocusableElements(builderRef.current);
      const activeElement = document.activeElement;

      const isInLeftPanel = leftPanelElements.includes(activeElement);

      if (isInLeftPanel) {
        // Currently in left panel, move to builder
        if (builderElements.length > 0) {
          if (event.shiftKey) {
            // Alt+Shift+B focuses last builder element
            builderElements[builderElements.length - 1]?.focus();
          } else {
            // Alt+B focuses first builder element
            builderElements[0]?.focus();
          }
        }
      } else {
        // Currently in builder, move to left panel
        if (leftPanelElements.length > 0) {
          if (event.shiftKey) {
            // Alt+Shift+B focuses last left panel element
            leftPanelElements[leftPanelElements.length - 1]?.focus();
          } else {
            // Alt+B focuses first left panel element
            leftPanelElements[0]?.focus();
          }
        }
      }
    }
  });

  const executeProductApproval = async (override = false) => {
    const res = await approveProduct({
      override,
      onSuccess: async () => {
        const result = await getCurrentUserAPI();
        if (result.success) {
          setLiveCounterData(result.results);
        }
        setActiveKey('offer')
      }
    });
    if (res?.error) {
      notification.open({
        message: res.error?.message,
        description: res.error?.description || '',
        type: res.error?.type || 'error',
      });
    } else {
      setActiveKey('offer')
    }
  };

  const handleApproveProduct = async (skipOcrValidation = false, skipVarietiesCheck = false) => {
    // Check for select varieties warning
    if (!skipVarietiesCheck) {
      const store = useAdBlockStore.getState();
      const hasAdultBeverage = store.products?.some(product => product.is_adult_bev === true) || false;
      const selectedVarietiesEnabled = Boolean(store.select_varieties_f);
      const apiSelectedVarietiesEnabled = Boolean(activeBlockData?.select_varieties_f);
      const selectedVarietiesTurnedOffFromApi = apiSelectedVarietiesEnabled && !selectedVarietiesEnabled;

      if ((selectedVarietiesEnabled && !hasAdultBeverage) || selectedVarietiesTurnedOffFromApi) {
        const warningMessages = [];
        if (selectedVarietiesEnabled && !hasAdultBeverage) {
          warningMessages.push("Selected Varieties is checked but no adult beverage product was found.");
        }
        if (selectedVarietiesTurnedOffFromApi) {
          warningMessages.push("Selected Varieties was detected by system but is now unchecked.");
        }

        setSelectVarietiesWarningMessage(`${warningMessages.join(' ')} Are you sure you want to continue?`);
        setPendingSkipOcrValidation(skipOcrValidation);
        setIsSelectVarietiesWarningOpen(true);
        return;
      }
    }
    // OCR-based validation checks (config-driven)
    if (!skipOcrValidation) {
      const ocrText = (activeBlockData?.ocr_text || '').toLowerCase();
      const currentProducts = useAdBlockStore.getState().products;
      for (const rule of OCR_VALIDATION_RULES) {
        if (ocrText.includes(rule.ocrKeyword.toLowerCase())) {
          const anyProductHasKeyword = currentProducts.some(product => {
            const brandName = (product.brand_nm || '').toLowerCase();
            return brandName.includes(rule.ocrKeyword.toLowerCase());
          });
          if (!anyProductHasKeyword) {
            const hasViolation = currentProducts.some(product => {
              const brandName = (product.brand_nm || '').toLowerCase();
              return rule.productMatch(brandName);
            });
            if (hasViolation) {
              setPendingSkipOcrValidation(skipOcrValidation);
              setOcrValidationModal({ open: true, rule });
              return;
            }
          }
        }
      }
    }

    // Check for size discrepancies
    const products = useAdBlockStore.getState().products;
    const unitResMessage = unitSizeRestrictionMessage(products);

    if (Object.keys(unitResMessage).length > 0) {
      // Show warning modal if there are size discrepancies
      setUnitRestrictionMessage(unitResMessage);
      setUnitRestrictionModal(true);
      return;
    }

    // Check for Ready to Drink Tea brands with size > 20 oz
    if (checkTeaSizeViolation(products, productSizes)) {
      setTeaSizeWarningModal(true);
      return;
    }

    // No discrepancies, proceed with approval
    await executeProductApproval();
  };

  const handleApproveOffer = async ({ override = false, skipCraftBeerCheck = false } = {}) => {
    const offerData = useAdBlockStore.getState().offers;
    const productData = useAdBlockStore.getState().products;
    let incentiveData = useAdBlockStore.getState().incentives;

    //Check for space after slash in offers and incentives
    let errorMessage = checkSpaceAfterSlash(offerData, incentiveData);
    if (errorMessage) {
      setSpaceWarningMessage(errorMessage);
      setSpaceWarningModalOpen(true);
      return;
    }

    // AD-4177: remind entry people about unbranded Craft Beer BOGOs at certain retailers
    if (!skipCraftBeerCheck && isCraftBeerBogoViolation({
      products: productData,
      offers: offerData,
      retailerName: activeBlockData?.retailer_name,
    })) {
      setCraftBeerBogoModalOpen(true);
      return;
    }

    const checkPrice = validatePrice({ offer_data: offerData, products_data: productData })
    if (!checkPrice.isValid && !override) {
      setPriceWarningMessage(checkPrice.reason);
      setPriceWarningModelOpen(true);
      return;
    }

    if (incentiveData) {
      incentiveData = incentiveData.filter(
        (a) => a?.incentive_attach_to === "Adblock"
      )
    }
    if (useAdBlockStore.getState().products.length === 0 || (offerData.length === 0 && incentiveData.length === 0 && !useAdBlockStore.getState().brand_equity_f)) {
      useAdBlockStore.setState({ isApproving: false })
      notification.open({
        message: "No products or offers to approve",
        type: 'warning',
      });
      return; // exit if error
    }
    if (offerData.length > 0 || incentiveData.length > 0) {
      const linerValidation = validateLiner({
        productData: productData,
        incentiveData: incentiveData,
        offerData: offerData,
      })
      if (!linerValidation.success && linerValidation.message) {
        notification.open({
          message: linerValidation.message,
          type: 'warning',
        });
        return; // exit if error
      }
    }

    const int_keys = [
      "reg_price",
      "reg_price2_d",
      "limit",
      "min_qty",
      "min_qty_dollar_f"
    ];

    offerData.forEach((offer, index) => {
      int_keys.forEach(key => {
        if (offer[key] === undefined || offer[key] === "") {
          offer[key] = null;
        }
        if (key === 'min_qty' || key === 'min_qty_dollar_f') {
          const { min_qty, min_qty_dollar_f } = checkMinQtyDollarF(offer.offer_text, offer.offer_type);
          offer['min_qty'] = min_qty;
          offer['min_qty_dollar_f'] = min_qty_dollar_f;
        }
      });
      offer['order_num'] = index
    });

    if (!force && offerData.length > 1 && !activeBlockData.split) {
      const offersToCalculate = offerData.filter(offer => offer.include_in_net_cost_f === true);
      const cal = await calculateNetCost({
        offers: offersToCalculate,
        setNetUnitPriceValue: (value) => setNetCostValues(value),
        setShowNetUnitPriceModal: (value) => setNetUnitPriceModal(value),
        setIsSubmitting: (value) => useAdBlockStore.setState({ isApproving: value }),
      });
      if (!cal.success) {
        useAdBlockStore.setState({ isApproving: false });
        return {
          success: false,
          message: cal.message || "Net cost calculation failed",
          values: cal.values || []
        };
      }
    }
    const res = await approveOffer({ skipValidation: false, netCostValues });
    if (res.success) {
      const result = await getCurrentUserAPI();
      if (result.success) {
        setLiveCounterData(result.results);
      }
      setForce(false);
    } else {
      if (res.canOverride) {
        setAdblockValidationMessage(res.message);
        setShowAdblockValidationModal(true);
      } else if (res.setLargeSaveOfferMessage) {
        setLargeSaveOfferMessage(res.setLargeSaveOfferMessage);
        setLargeSaveOfferModalOpen(true);
      } else if (res.message || res?.error) {
        notification.open({
          message: res.message || res.error?.message,
          description: res.error?.description || '',
          type: res.error?.type || 'error',
        });
      }
    }
  }

  const handleSuccessDupeAdBlock = () => {
    setTimeout(() => setActiveBlockData(activeBlockData.uuid), 1000);
  };

  return (
    <Layout style={{ minHeight: '100vh', background: '#131313' }}>
      <Nav />
      <Layout>
        <PageActions />
        <Layout>
          <Sider width={"15%"} style={{
            background: '#131313',
            borderRight: '1px solid rgba(255, 255, 255, 0.1)',
          }}>
            <Row>
              <Col span={24} >
                <Layout>
                  <Header style={{
                    background: '#131313',
                    color: '#909090',
                    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                    height: '38px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '0 16px',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    letterSpacing: '0.25px',
                    textTransform: 'uppercase',
                  }}>
                    Page Image
                  </Header>
                  <Content style={{
                    background: '#131313',
                    padding: '16px',
                    height: '25vh',
                    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                    display: 'flex',
                    flexDirection: 'column',
                  }}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexDirection: 'column',
                      flex: 1,
                      minHeight: 0,
                    }}>
                      {activePageData?.filename ? (
                        <PageImagePreview
                          filename={activePageData.filename}
                          pageWidth={activePageData.pageWidth}
                          pageHeight={activePageData.pageHeight}
                          id={`AdBlock-${adblock}`}
                          showOverlay={true}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                            maxWidth: '100%',
                            maxHeight: '100%',
                          }}
                        />
                      ) : (
                        <Spin size="large" indicator={<div className='spinner-border' />} />
                      )}
                    </div>
                  </Content>
                </Layout>
              </Col>
              <Col span={24}>
                <EventSelector />
              </Col>
              <Col span={24}>
                <Layout style={{ height: 'calc(100vh - 25vh - 64px - 64px - 200px)' }}>
                  <Header style={{
                    background: '#131313',
                    color: '#909090',
                    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                    height: '38px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '0 16px',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    letterSpacing: '0.25px',
                    textTransform: 'uppercase',
                  }}>
                    Meta Data Info
                  </Header>
                  <ScrollView style={{ padding: '16px', background: '#131313', height: '100%', width: '100%' }}>
                    <MetaDataSelector />
                  </ScrollView>
                </Layout>
              </Col>
            </Row>
          </Sider>
          <Layout style={{
            background: '#131313',
            color: 'white',
          }}>
            <Header style={{
              background: '#131313',
              color: '#909090',
              borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
              height: '38px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '0 16px',
              textTransform: 'uppercase',
            }}>
              <span style={{
                letterSpacing: '0.25px',
                fontSize: '12px',
                fontWeight: 'bold',
              }}>
                Block Image
              </span>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {activeBlockData?.is_dupe && <a target="_blank"
                  href={location.origin + '/edit/' + activeBlockData?.dupe_circular_uuid + "/" + activeBlockData?.dupe_page_uuid + "/" + activeBlockData?.dupe_adblock_uuid}>
                  <Tag color="blue-inverse">DUPLICATE</Tag>
                </a>
                }
                {activeBlockData?.product_dupe_of && <a target="_blank" href={location.origin + '/edit/' + activeBlockData?.similar_circular_uuid + "/" + activeBlockData?.similar_page_uuid + "/" + activeBlockData?.similar_adblock_uuid}>
                  <Tag color="cyan">PRODUCT DUPE</Tag>
                </a>
                }
                {activeBlockData?.offer_dupe_of && <a target='_blank' href={location.origin + '/edit/' + activeBlockData?.similar_circular_uuid + "/" + activeBlockData?.similar_page_uuid + "/" + activeBlockData?.similar_adblock_uuid}>
                  <Tag color="cyan">OFFER DUPE</Tag>
                </a>}
                {isGeneratingSuggestions && <Tag color="gold" title="We're still generating product suggestions for this image">GENERATING SUGGESTIONS</Tag>}
                <AgentTraceLink traceId={imageMatchTraceId} />
                {activeBlockData?.section !== null && <Tag color="magenta-inverse">SECTION</Tag>}
                {activeBlockData?.approved && <Tag color="green-inverse">COMPLETED</Tag>}
                <Button 
                  icon={<IoTextOutline />} 
                  type={showOcrText ? 'primary' : 'icon'} 
                  size='small'
                  onClick={() => setShowOcrText(!showOcrText)}
                  title={showOcrText ? 'Hide OCR/HTML Text' : 'Show OCR/HTML Text'}
                />
              </div>
            </Header>
            <Content style={{
              background: '#131313',
              overflow: 'hidden',
              display: "flex",
              flex: 1,
            }}>
              <div style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
              }}>
                <ImagePreview
                  filename={activeBlockData?.filename}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                  }}
                />
                {showOcrText && (
                  <OCRPanel
                    ocrText={activeBlockData?.ocr_text}
                    htmlText={activeBlockData?.html_text}
                    setShowOcrText={setShowOcrText}
                  />
                )}
              </div>
            </Content>
          </Layout>
          <Sider width={"45%"} style={{
            background: '#131313',
            borderLeft: '1px solid rgba(255, 255, 255, 0.1)',
          }}>
            <Tabs
              activeKey={activeKey}
              onChange={setActiveKey}
              defaultActiveKey="product"
              items={tabItems}
              className="custom-tabs"
              tabBarStyle={{
                userSelect: 'none',
                paddingLeft: '16px',
              }}
              style={{ height: '100%' }}
              // animated={false}
              size='small'
              type='line'
              tabBarExtraContent={
                <div className='d-flex'>
                  {activeKey === 'product' &&
                    <>
                      <span style={{
                        marginRight: 16,
                        color: '#909090'
                      }}>
                        {currentProduct?.index + 1 || 0} / {products.length}
                      </span>
                      <Button
                        icon={<IoCheckmark />}
                        size='small'
                        onClick={async () => { await handleApproveProduct(); }} className='ml-2 cursor-pointer'
                        type={approveButtonStyle().type}
                        disabled={isLoading || isApproving || isRejecting || isDNELoading || products.some(product => !product.isValid) || activeBlockData.is_dupe || checkDupeEntry(products)}
                      >
                        {approveButtonStyle().text}
                      </Button>
                      <Button
                        icon={<IoAdd />}
                        iconPosition='end'
                        size='small'
                        onClick={() => useAdBlockStore.getState().addProduct()}
                        className='ml-2 mr-2 cursor-pointer'
                        disabled={isLoading || isApproving || isRejecting || isDNELoading || activeBlockData.is_dupe}
                      >
                        PRODUCT
                      </Button>
                    </>
                  }
                  {activeKey === 'offer' &&
                    <>
                      <span style={{
                        marginRight: 16,
                        color: '#909090'
                      }}>
                        {currentOffer?.index + 1 || 0} / {offers.length + incentives.length}
                      </span>
                      <Button
                        icon={<IoCheckmark />}
                        size='small'
                        onClick={async () => { await handleApproveOffer(); }}
                        className='ml-2 cursor-pointer'
                        type={approveButtonStyle().type}
                        disabled={isLoading || isApproving || isRejecting || isDNELoading || offers.some(offer => !offer.isValid) || incentives.some(incentive => !incentive.isValid) || !arePriceEaOffersValid || activeBlockData.is_dupe || (split && products.length !== offers.length) }
                      >
                        {approveButtonStyle().text}
                      </Button>
                      <Button icon={<IoAdd />} size='small' iconPosition='end' type='dashed'
                        disabled={isLoading || isApproving || isRejecting || isDNELoading || activeBlockData.is_dupe}
                        onClick={() => { useAdBlockStore.getState().addNewOffer(); }}
                        className='mx-2 cursor-pointer'>Offer</Button>
                      <Button icon={<IoAdd />} size='small' iconPosition='end' type='dashed'
                        disabled={isLoading || isApproving || isRejecting || isDNELoading || activeBlockData.is_dupe}
                        onClick={() => { useAdBlockStore.getState().addNewIncentive(); }}
                        className='mr-1 cursor-pointer'>Incentive</Button>
                    </>
                  }
                </div>
              }
            />
          </Sider>
        </Layout>
      </Layout>
      <Footer />
      <ImageMatchingModal
        {...imageMatchingModal}
        currentAdBlockData={activeBlockData}
        circularName={circularName} sizeData={productSizes}
        dupe_block={activeBlockData.similar_adblock_uuid}
        onSuccess={navigateNextUnapproved}
        onSuccessDupeAdBlock={handleSuccessDupeAdBlock}
        view={activeKey}
        ttb={false}
        startTime={new Date().toISOString().replace(',', '')} // update if starTime is needed
        onImport={(data) => {
          if (activeKey === 'product') handleImportProduct(data)
          else if (activeKey === 'offer') handleImportOffer(data)
        }}
        ResetViewOnClose={true}
        onError={(err) => { notification.open({ message: err, type: 'error', }) }}
      />
      <NetUnitPriceModal
        isVisible={netUnitPriceModal}
        calculatedValues={netCostValues}
        onConfirm={async () => {
          setNetUnitPriceModal(false);
          setForce(true);
          const res = await approveOffer({ skipValidation: false, netCostValues: netCostValues });
          if (!res.success) {
            notification.open({
              message: res.message,
              type: 'error'
            });
          }
        }}
        onCancel={() => {
          setNetUnitPriceModal(false);
        }}
      />
      <UnitRestrictionWarning
        open={unitRestrictionModal}
        onClose={() => setUnitRestrictionModal(false)}
        unitRestrictionMessage={unitRestrictionMessage}
        onApprove={() => executeProductApproval(true)}
      />
      <TeaSizeWarning
        open={teaSizeWarningModal}
        onClose={() => setTeaSizeWarningModal(false)}
        onApprove={() => executeProductApproval(true)}
      />
      <Modal
        title="Price Warning"
        open={priceWarningModelOpen}
        okText="Override and Approve"
        onOk={async () => {
          const res = await overrideAdblock(activeBlockData.uuid);
          if (res.success) {
            await handleApproveOffer({
              override: true,
              skipCraftBeerCheck: true
            });
            setPriceWarningModelOpen(false);
          }
        }}
        onCancel={() => setPriceWarningModelOpen(false)}
        style={{
          top: 0,
          right: 0,
          position: 'absolute',
        }}
      >
        {priceWarningMessage}
      </Modal>
      <Modal
        title="Large Save Offer Validation Error"
        open={largeSaveOfferModalOpen}
        okText="Override and Approve"
        onOk={async () => {
          const res = await overrideAdblock(activeBlockData.uuid);
          if (res.success) {
            await handleApproveOffer({ override: true, skipCraftBeerCheck: true });
            setLargeSaveOfferModalOpen(false);
          }
        }}
        onCancel={() => setLargeSaveOfferModalOpen(false)}
        style={{
          top: 0,
          right: 0,
          position: 'absolute',
        }}
      >
        {largeSaveOfferMessage}
      </Modal>
      <Modal
        title={ocrValidationModal.rule?.title || 'OCR Validation Warning'}
        open={ocrValidationModal.open}
        okText="Approve Anyway"
        onOk={() => {
          setOcrValidationModal({ open: false, rule: null });
          handleApproveProduct(pendingSkipOcrValidation || true, true);
        }}
        onCancel={() => setOcrValidationModal({ open: false, rule: null })}
        style={{ top: 0, right: 0, position: 'absolute' }}
      >
        {ocrValidationModal.rule?.message}
        {ocrValidationModal.rule?.linkUrl && (
          <>
            <br />
            <a href={ocrValidationModal.rule.linkUrl} target="_blank" rel="noopener noreferrer">
              {ocrValidationModal.rule?.linkText || 'View Methodology'}
            </a>
          </>
        )}
      </Modal>
      <Modal
        title="Methodology Reminder"
        open={craftBeerBogoModalOpen}
        okText="Approve Anyway"
        cancelText="Go Back"
        onOk={() => {
          setCraftBeerBogoModalOpen(false);
          handleApproveOffer({ skipCraftBeerCheck: true });
        }}
        onCancel={() => setCraftBeerBogoModalOpen(false)}
        style={{ top: 0, right: 0, position: 'absolute' }}
      >
        <div style={{ whiteSpace: 'pre-line' }}>
          {CRAFT_BEER_BOGO_MESSAGE.split(/(https?:\/\/[^\s]+)/g).map((part, i) =>
            /^https?:\/\//.test(part) ? (
              <a key={i} href={part} target="_blank" rel="noopener noreferrer">{part}</a>
            ) : (
              part
            )
          )}
        </div>
      </Modal>
      <Modal
        title="Selected Varieties Warning"
        open={isSelectVarietiesWarningOpen}
        okText="Continue Anyway"
        onOk={() => {
          setIsSelectVarietiesWarningOpen(false);
          handleApproveProduct(pendingSkipOcrValidation, true);
        }}
        onCancel={() => setIsSelectVarietiesWarningOpen(false)}
        style={{ top: 0, right: 0, position: 'absolute' }}
      >
        {selectVarietiesWarningMessage}
      </Modal>
      <Modal
        title="AdBlock Validation"
        open={showAdblockValidationModal}
        okText="Override and Approve"
        onOk={async () => {
          const res = await overrideAdblock(activeBlockData.uuid);
          if (res.success) {
            setForce(true);
            await approveOffer({ skipValidation: true, netCostValues });
            setShowAdblockValidationModal(false);
          }
        }}
        onCancel={() => setShowAdblockValidationModal(false)}
        style={{
          top: 0,
          right: 0,
          position: 'absolute',
        }}
      >
        {adblockValidationMessage}
      </Modal>
      <SpaceAfterSlashWarningModal
        open={spaceWarningModalOpen}
        message={spaceWarningMessage}
        onClose={() => setSpaceWarningModalOpen(false)}
      />
    </Layout>
  );
}
